import Vue from "vue";
import Vuex from "vuex";
// import permission from "./modules/permission";
// import teachParamXL from "./modules/TechParamXL";
import topSelect from "./modules/topSelect";
import closeAddCompany from "./modules/closeAddCompany";
import bjjk from "./modules/bjjk";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        // permission,
        // teachParamXL,
        topSelect,
        closeAddCompany,
        bjjk
    }
});
